const DISTANCE_MARKS = [
	{
		value: 0,
		label: '25km',
	},
	{
		value: 1,
		label: '50km',
	},
	{
		value: 2,
		label: '75km',
	},
	{
		value: 3,
		label: '100km',
	},
];

const DISTANCE_MARKS_ODONTO = [
	{
		value: 0,
		label: '0km',
	},
	{
		value: 1,
		label: '25km',
	},
	{
		value: 2,
		label: '35km',
	},
	{
		value: 3,
		label: '45km',
	},
	{
		value: 4,
		label: '50km',
	},
];

const DISTANCE_VALUES = [25, 50, 75, 100];
const DISTANCE_VALUES_ODONTO = [0, 25, 35, 45, 50];

export {DISTANCE_MARKS, DISTANCE_VALUES, DISTANCE_MARKS_ODONTO, DISTANCE_VALUES_ODONTO};
